"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Long = require("long");

var Utf8ArrayToStr_1 = require("./libs/Utf8ArrayToStr");

var base58_1 = require("./libs/base58");

var Base64 = require("base64-js");

exports.ALIAS_VERSION = 2;
var LENGTH_SIZE = 2;

exports.P_OPTION = function (p) {
  return function (bytes) {
    var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (bytes[start] === 0) return {
      value: null,
      shift: 1
    };
    var result = p(bytes, start + 1);
    return {
      value: result.value,
      shift: result.shift + 1
    };
  };
};

exports.P_BYTE = function (bytes) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return {
    value: bytes[start],
    shift: 1
  };
};

exports.P_SHORT = function (bytes) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return {
    value: 256 * bytes[start] + bytes[start + 1],
    shift: 2
  };
};

exports.P_INT = function (bytes) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return {
    value: Math.pow(2, 24) * bytes[start] + Math.pow(2, 16) * bytes[start + 1] + Math.pow(2, 8) * bytes[start + 2] + bytes[start + 3],
    shift: 4
  };
};

exports.P_LONG = function (bytes) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return {
    value: Long.fromBytesBE(Array.from(bytes.slice(start, start + 8))).toString(),
    shift: 8
  };
};

exports.P_BOOLEAN = function (bytes) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var value = !!bytes[start];
  return {
    value: value,
    shift: 1
  };
};

exports.P_STRING_FIXED = function (len) {
  return function (bytes) {
    var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var value = Utf8ArrayToStr_1.Utf8ArrayToStr(bytes.slice(start, start + len));
    return {
      shift: len,
      value: value
    };
  };
};

exports.P_STRING_VAR = function (lenParser) {
  return function (bytes) {
    var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var lengthInfo = lenParser(bytes, start);

    var _exports$P_STRING_FIX = exports.P_STRING_FIXED(lengthInfo.value)(bytes, start + lengthInfo.shift),
        value = _exports$P_STRING_FIX.value;

    return {
      shift: lengthInfo.value + lengthInfo.shift,
      value: value
    };
  };
};

exports.P_BASE58_FIXED = function (len) {
  return function (bytes) {
    var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var value = base58_1.default.encode(bytes.slice(start, start + len));
    return {
      value: value,
      shift: len
    };
  };
};

exports.P_BASE58_VAR = function (lenParser) {
  return function (bytes) {
    var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var lengthInfo = lenParser(bytes, start);

    var _exports$P_BASE58_FIX = exports.P_BASE58_FIXED(lengthInfo.value)(bytes, start + LENGTH_SIZE),
        value = _exports$P_BASE58_FIX.value;

    return {
      shift: lengthInfo.value + LENGTH_SIZE,
      value: value
    };
  };
};

exports.P_BASE64 = function (lenParser) {
  return function (bytes) {
    var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var lengthInfo = lenParser(bytes, start);
    var value = "base64:".concat(Base64.fromByteArray(bytes.slice(start + lengthInfo.shift, start + lengthInfo.shift + lengthInfo.value)));
    return {
      shift: lengthInfo.value + lengthInfo.shift,
      value: value
    };
  };
};

var byteToString = function byteToString(shift) {
  return function (bytes, start) {
    var value = Utf8ArrayToStr_1.Utf8ArrayToStr(bytes.slice(start, start + shift));
    return {
      shift: shift,
      value: value
    };
  };
};

exports.byteToStringWithLength = function (bytes) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var lengthInfo = exports.P_SHORT(bytes, start);

  var _byteToString = byteToString(lengthInfo.value)(bytes, start + LENGTH_SIZE),
      value = _byteToString.value;

  return {
    shift: lengthInfo.value + LENGTH_SIZE,
    value: value
  };
};

exports.byteToBase58 = function (bytes) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var length = arguments.length > 2 ? arguments[2] : undefined;
  var shift = length || 32;
  var value = base58_1.default.encode(bytes.slice(start, start + shift));
  return {
    value: value,
    shift: shift
  };
};

exports.byteToBase58WithLength = function (bytes) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var lenInfo = exports.P_SHORT(bytes, start);
  var value = base58_1.default.encode(bytes.slice(start + lenInfo.shift, start + lenInfo.shift + lenInfo.value));
  return {
    value: value,
    shift: lenInfo.shift + lenInfo.value
  };
};

exports.byteToAddressOrAlias = function (bytes) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (bytes[start] === exports.ALIAS_VERSION) {
    var aliasData = exports.byteToStringWithLength(bytes, start + 2);
    return {
      shift: aliasData.shift + 2,
      value: "alias:".concat(String.fromCharCode(bytes[start + 1]), ":").concat(aliasData.value)
    };
  } else {
    return exports.byteToBase58(bytes, start, 26);
  }
};

exports.byteNewAliasToString = function (bytes) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var shift = exports.P_SHORT(bytes, start).value + LENGTH_SIZE;

  var _exports$byteToString = exports.byteToStringWithLength(bytes, start),
      value = _exports$byteToString.value;

  return {
    shift: shift,
    value: value
  };
};

exports.byteToScript = function (bytes) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var VERSION_LENGTH = 1;

  if (bytes[start] === 0) {
    return {
      shift: VERSION_LENGTH,
      value: null
    };
  }

  var lengthInfo = exports.P_SHORT(bytes, start + VERSION_LENGTH);
  var from = start + VERSION_LENGTH + lengthInfo.shift;
  var to = start + VERSION_LENGTH + lengthInfo.shift + lengthInfo.value;
  var value = "base64:".concat(Base64.fromByteArray(bytes.slice(from, to)));
  return {
    value: value,
    shift: to - start
  };
};